module.exports = __webpack_public_path__ + "img/hamburger.1229239f.svg";